import {Directive, HostListener, ElementRef} from '@angular/core'

/**
 * This directive removes focus from the selectors after clicking on them
 */
@Directive({
  selector: 'button, a'
})
export class FocusRemover {
  constructor(private elRef: ElementRef) {}

  @HostListener('click') onClick() {
    this.elRef.nativeElement.blur()
    Array.from(document.getElementsByTagName('nb-tooltip')).map(t => {t.setAttribute('hidden', 'true')})
  }
}
